module.exports = __webpack_public_path__ + "static/media/M111ws.6d568d48.pdf";